/**
 * Resolves an imageLink from the API into a valid public URL.
 *
 * API returns paths like "assets/img/icons/db/s3.svg" or
 * "assets/img/icons/transformations/Aggregation.svg".
 *
 * Since these assets live in the `public/` folder, they are
 * served at the root — we just prepend "/".
 */
export function resolveIconUrl(imageLink: string | null): string | null {
    if (!imageLink) return null;
    // Already absolute or data-URI — return as-is
    if (imageLink.startsWith('/') || imageLink.startsWith('data:')) return imageLink;
    return `/${imageLink}`;
}
